import store from '@/store'

export function delChild(arr) {//删除空children
    return arr.map(item => {
        // 创建新对象副本
        const newItem = { ...item };
        // 如果有 children 属性且不为空，则递归处理
        if (item.children && item.children.length > 0) {
            newItem.children = delChild(item.children);
        } else if (item.children && item.children.length === 0) {
            // 如果 children 是空数组，则删除该属性
            delete newItem.children;
        }
        return newItem;
    });

}
export function textareaHtml(remark){//富文本
    if(!remark) return '--'
    let string = remark + ''
    if (string) {
        // return remark.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
        return string
        // 预先处理HTML特殊字符以防止XSS攻击
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        // 处理换行
        .replace(/\r\n/g, '<br>')
        .replace(/\n/g, '<br>')
        // 保持空格和缩进
        .replace(/  /g, '&nbsp;&nbsp;') // 连续两个空格转为不间断空格
        .replace(/ /g, '&nbsp;');       // 单个空格转为不间断空格
    }else{
        return '--'
    }
}

//用户权限
export async function checkPerm(perms,enterpriseId) {//用户权限
    let isLogin = store.getters.isLogin   //是否登录 
    if(isLogin){
        try{
            await store.dispatch('user/getInfo')
            let customerType = store.getters.userInfo.customerType //用户类型
            let companyId = store.getters.userInfo.companyId   //公司ID 
            
            if(enterpriseId == companyId || perms.includes(customerType)){
                return true
            }else {
                return false
            }
        }catch(e){
            console.warn(e)
        }
    }else{
        return false
    }
    

}
//检查 是否禁用
export function disabledPerm(perms) {//用户权限
    let isLogin = store.getters.isLogin   //是否登录 
    if(isLogin){
        // await store.dispatch('user/getInfo')
        let customerType = store.getters.userInfo.customerType //用户类型
        if( perms.includes(customerType)==false){
            return 1
        }else{
            return false
        }
    }else{
        return 2
    }
}

export  function authPerm(perms){
    let {businessAuth,realNameAuth,personalAuth} = store.getters.generalData
    let isLogin = store.getters.isLogin   //是否登录
    if(isLogin){
        // await store.dispatch('user/getInfo')
        var customerType = store.getters.userInfo.customerType
        if( perms.includes(customerType) == false){//没有权限
            return 1
        }else if(businessAuth == false || realNameAuth == false || personalAuth == false){
            return 2
        }else{//有权限
            return false
        }
       
    }else{
        return 9
    }
}